import MDSImpl from "./MdsImpl";

export default MDSImpl;
